import { App } from 'vue'
import { registerElement } from '@/global/register-element'
import { registerProperties } from '@/global/register-properties'
import { registerCustom } from './register-custom'

export function registerApp(app: App): void {
  app.use(registerElement)
  app.use(registerProperties)
  app.use(registerCustom)
}
